export const MY_RECORD_DATA = 'MY_RECORD_DATA'
export const CANCEL_RECORD_LIST = 'CANCEL_RECORD_LIST'
export const UPDATE_COUPON_INFO_RECORD = 'UPDATE_COUPON_INFO_RECORD'
export const UPDATE_COUPON_INFO_FALSE_RECORD = 'UPDATE_COUPON_INFO_FALSE_RECORD'
export const GET_COUPON_DETAIL = 'GET_COUPON_DETAIL'



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/store/mutations-types.js